import type { ActionData } from '@/types';
import gsap from 'gsap';
import type { Element } from '../../canvas/element';

export class Action {
  protected _data: ActionData;

  protected _element: Element | null = null;

  protected _tween: gsap.core.Timeline | null = null;
  protected mainTween: gsap.core.Timeline | null = null;

  // protected enterMotion: Motion | null = null;
  // protected exitMotion: Motion | null = null;
  // protected emphasisMotions: Motion[] = [];

  protected time = { n: 0 };

  constructor(data: ActionData, element: Element) {
    this._data = data;
    this._element = element;
  }

  public init(): void {
    this.initTimeline();
    this.initMotions();
    this.doRefreshMotion();
  }

  public initTimeline(): void {
    this._tween = this._tween || gsap.timeline(); // 初始化时，不能paused，不然插入主时间轴时，控制不了
    this._tween.clear();
    this._tween.timeScale(1);
    this._tween.startTime(this._data.startTime);

    this.mainTween = this.mainTween || gsap.timeline();
    this.mainTween.clear();
    this.mainTween.timeScale(1);
    this.mainTween.startTime(0);

    this._tween.add(this.mainTween);
  }

  protected initMotions(): void {
    // if (!this._data) return;
    // this.destroyMotion();
    // const motions: MotionData[] = [
    //   ...(this._data.enterMotion ? [this._data.enterMotion] : []),
    //   ...(this._data.emphasisMotions || []),
    //   ...(this._data.exitMotion ? [this._data.exitMotion] : [])
    // ];
    // motions.forEach((motion) => {
    //   this.addMotion(createMotion(motion));
    // });
  }

  protected doRefreshMotion(): void {
    // const motions = this.motions;
    // if (!motions || motions.length === 0) {
    //   // 没有动画时，添加一个占位 tween 让元素在整个 action 期间可见
    //   // 这个 tween 不会改变元素状态，只是让 timeline 有正确的时长
    //   this.mainTween?.to(this.time, { n: 1, duration: this._data.duration, ease: 'none', immediateRender: false }, 0);
    //   return;
    // }
    // this.sortMotions();
    // let lastMotion: Motion | null = null;
    // for (const motion of motions) {
    //   motion.element = this.element;
    //   motion.init();
    //   if (lastMotion) motion.originElementData = lastMotion.targetElementData;
    //   if (motion.tween) this.mainTween?.add(motion.tween, motion.startTime);
    //   lastMotion = motion;
    // }
  }

  // public addMotion(motion: Motion) {
  //   if (motion.isEnter) {
  //     this.enterMotion?.destory();

  //     this.enterMotion = motion;
  //   } else if (motion.isExit) {
  //     this.exitMotion?.destory();

  //     this.exitMotion = motion;
  //   } else {
  //     this.emphasisMotions.push(motion);
  //   }
  // }

  // protected sortMotions() {
  //   sortActionMotion(this._data);

  //   const motions = this.motions;
  //   if (!motions) return;

  //   if (this.enterMotion && this._data.enterMotion) {
  //     const { startTime, duration } = this._data.enterMotion;
  //     this.enterMotion.updateTimeInfo({ startTime, duration }, false);
  //   }

  //   if (this.exitMotion && this._data.exitMotion) {
  //     const { startTime, duration } = this._data.exitMotion;
  //     this.exitMotion.updateTimeInfo({ startTime, duration }, false);
  //   }

  //   if (this.emphasisMotions && this._data.emphasisMotions) {
  //     for (const data of this._data.emphasisMotions) {
  //       const target = this.emphasisMotions.find((motion) => motion.id === data.id);

  //       const { startTime, duration } = data;
  //       target?.updateTimeInfo({ startTime, duration }, false);
  //     }
  //   }
  // }

  public updateTimeInfo(info: { startTime?: number; duration?: number }) {
    Object.assign(this._data, info);

    this.refresh();
  }

  /**
   * 刷新时间线
   */
  public refresh() {
    this._tween?.startTime(this._data.startTime);
    this.doRefreshMotion();
  }

  /**
   * 刷新元素
   */
  public refreshElement() {
    this._element?.refresh();
    // this.refreshMotions();

    //只刷新一下动画里面的元素数据
    // const motions = this.motions;

    // if (!motions || motions.length === 0) return;
    // let lastMotion: Motion | null = null;
    // for (const motion of motions) {
    //   motion.refreshElementData();
    //   if (lastMotion) motion.originElementData = lastMotion.targetElementData;
    //   lastMotion = motion;
    // }
  }

  public refreshMotions() {
    this.doRefreshMotion();
  }

  public destroyMotion(): void {
    // if (!this.motions) return;
    // this.motions.forEach((motion) => {
    //   if (motion.tween) {
    //     this.mainTween?.remove(motion.tween);
    //   }
    // });
    // if (this.enterMotion) {
    //   this.enterMotion.destory();
    //   this.enterMotion = null;
    // }
    // if (this.exitMotion) {
    //   this.exitMotion.destory();
    //   this.exitMotion = null;
    // }
    // if (this.emphasisMotions) {
    //   this.emphasisMotions.forEach((motion) => {
    //     motion.destory();
    //   });
    //   this.emphasisMotions = [];
    // }
  }

  public destroy(): void {
    this._element?.destroy();

    this.destroyMotion();

    this.mainTween?.clear();
    this.mainTween?.kill();
    this.mainTween = null;

    this._tween?.clear();
    this._tween?.kill();
    this._tween = null;
  }

  public get tween(): gsap.core.Timeline | null {
    return this._tween;
  }

  public get id(): string {
    return this._data.id;
  }

  /**
   * Action的时间信息
   */
  public get data(): ActionData {
    return this._data;
  }

  public set data(v: ActionData) {
    this._data = v;
  }

  public get element(): Element | null {
    return this._element;
  }

  public set element(v: Element | null) {
    this._element = v;
  }

  public get startTime(): number {
    return this._data.startTime;
  }

  public set startTime(v: number) {
    this._data.startTime = v;
    this.refresh();
  }

  public get duration(): number {
    return this._data.duration;
  }

  public set duration(v: number) {
    this._data.duration = v;
  }

  // public get motions(): Motion[] {
  //   let results: Motion[] = [];

  //   if (this.enterMotion) results = results.concat(this.enterMotion);

  //   if (this.emphasisMotions) results = results.concat(this.emphasisMotions);

  //   if (this.exitMotion) results = results.concat(this.exitMotion);

  //   return results;
  // }
}
